import * as React from "react";
import './FormPartner.css'
import {formStores} from "../../../state/mobx";
import PlacesAutoCompleteContainer from "../../../../Bots/Common/PlacesAutoComplete/PlacesAutoCompleteContainer";
import {IGooglePlace} from "shared/model/ICoworkGeoLocation";
import FormButton from "../../../../../components/FormButton/FormButton";
import {observer} from "mobx-react";
import {InputTypes} from "../../../components/FormStepper/InputTypes";
import FormStepper from "../../../components/FormStepper/FormStepper";
import FormFinish from "../../SignUpForm/FormFinish/FormFinish";
import { PartnersState } from "src/scenes/Forms/state/PartnersState";
// @ts-ignore
import ResetFormBtn from "../../../../../components/ResetForm/resetFormBtn";
import {RouteComponentProps} from "react-router";

interface IProps extends RouteComponentProps<any> {
    closeWindowNavigationPath : string;
}

interface ILocalState {
    inputValue: any;
    selectedOption: number;
    navigate : boolean;
    showWorkSpaceError: boolean;
}

const STORE = formStores.partnersStore;
const storePropertyName = "partners";

@observer
export default class FormPartner  extends React.Component<
    IProps,
    ILocalState
    > {

    public state: ILocalState = {
        inputValue: '',
        selectedOption: 0,
        navigate : false,
        showWorkSpaceError: false
    };

    constructor (props: IProps) {
        super(props);
        if(!STORE.formInput[storePropertyName]) {
            STORE.formInput[storePropertyName] = {};
        }
    }

    public closeWindow = () => {
        STORE.initState();
        STORE.updateScreen(PartnersState.welcome);
        this.setState({navigate: true});
    };

    public selectPlace = (place: IGooglePlace | string) => {
        const newState = this.state;
        newState.showWorkSpaceError = false;
        this.setState(newState);
        STORE.updateLocation(place);
    };

    public next = () => {
        if(STORE.formInput["location"]) {
            STORE.updateScreen(PartnersState.information);
        }else {
            const newState = this.state;
            newState.showWorkSpaceError = true;
            this.setState(newState);
        }
    };

    public renderNextButton = () => {
        // const classes = STORE.location ||  FormUtils.validateInput(InputTypes.text, this.state.inputValue) ? "yellow" : "disabled";
        return <FormButton classes={"yellow"} click={this.next} btnText={'Get started'}/>;
    };

    public getErrorMessage = () => {
        if(STORE.getEmailErrorMessage ===  "invalidMail") {
            return <div> The email address you provided is invalid </div>;
        }
        return null;
    }

    public renderSteps = () => {
        switch (STORE.currentScreen) {
            case PartnersState.welcome: {
                return (
                    <div className="welcome-container">
                        <div className="header">Welcome Workspace Operators!</div>
                        <div className="sub-header">Grow your space with operator financing and fill it with tenants by providing members deposit financing</div>
                        <div className="workspace-selection">
                            <PlacesAutoCompleteContainer  placeholder={"e.g Wework 430 Park Avenue, The Yard, Deskpass.."} inputLabel={"Please list your workspace"} onPlaceSelected={this.selectPlace}  autoFocus={true}/>
                            <div className="btn-container">
                                {this.renderNextButton()}
                                {this.state.showWorkSpaceError? <div className="error">This field is mandatory: Please list a workspace</div>: null}
                            </div>
                        </div>
                    </div>
                )
            }
            case PartnersState.information: {
                const verificationSteps: any = [
                    {
                        isHeader: true,
                        title: "Contact Information",
                        inputType: InputTypes.none
                    },
                    {
                        title: "Your Full Name",
                        inputType: InputTypes.text,
                        propName: "fullName",
                        inputPlaceHolder: "Write here...",

                    },
                    {
                        title: "Work Email Address",
                        inputType: InputTypes.email,
                        propName: "workEmail",
                        errorController: !STORE.isEmailValid,
                        errorLabel: this.getErrorMessage(),
                        inputPlaceHolder: "Write here...",
                    },
                    {
                        title: "Phone Number",
                        inputType: InputTypes.text,
                        propName: "phoneNumber",
                        inputPlaceHolder: "Write here...",
                    }
                    ,
                    {
                        title: "Your position at the workspace",
                        inputType: InputTypes.text,
                        propName: "workspacePosition",
                        inputPlaceHolder: "Write here...",
                    }
                ];

                return (<div>
                    <FormStepper steps={verificationSteps} store={STORE} navigationProperty={storePropertyName}/>
                </div>)
            }
            case PartnersState.finish: return <FormFinish {...this.props} isPartner={true} link={"http://www.salaryo.com/workspaces"}/> ;
            default: return null
        }
    };

    public submit = () => {
        if(STORE.allowFinishForm) {
            STORE.submit();
        }
    };

    public goBack = () => {
        STORE.updateLocation();
        STORE.updateScreen(PartnersState.welcome);
    }

    public renderNavigation = () => {
        if (STORE.currentScreen === PartnersState.information) {
            const btnClasses = STORE.allowFinishForm? 'yellow' : 'disabled';
            return (<div className="form-navigation">
                <ResetFormBtn/>
                <div className="link-next">
                    <FormButton btnText={"Submit"} classes={btnClasses} click={this.submit}/>
                </div>

            </div>);
        }
        return null;
    }

    public render() {
            return (
            <>
                {this.renderSteps()}
                {this.renderNavigation()}
            </>)
        }
    }




// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/FormPartners/FormPartners/FormPartner.tsx